import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface NotificationMessage {
  type: 'success' | 'danger' | 'info' | 'warning';
  message: string;
  actionText?: string;
  actionCallback?: () => void; // função executada ao clicar
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly notificationSubject = new Subject<NotificationMessage>();
  notification$ = this.notificationSubject.asObservable();

  show(type: NotificationMessage['type'], message: string): void {
    this.notificationSubject.next({ type, message });
  }

  success(msg: string) {
    this.show('success', msg);
  }

  error(msg: string) {
    this.show('danger', msg);
  }

  info(msg: string) {
    this.show('info', msg);
  }

  warning(msg: string) {
    this.show('warning', msg);
  }
}
